import { Factory } from 'rosie';

Factory.define('DeclinedReassignedSessionNotification');



// WEBPACK FOOTER //
// ./factories/declined_reassigned_session_notification_factory.js